import topic from '../topic';
export const muopAPI = {
  getMurfs: topic.muopTopic + '/getMurfs',
  addMurf: topic.muopTopic + '/addMurf',
  getMurfById: topic.muopTopic + '/getMurfById',
  editMurf: topic.muopTopic + '/editMurf',
  destroyMurfByIds: topic.muopTopic + '/destroyMurfByIds',
  editMurfProc: topic.muopTopic + '/editMurfProc'
};
